"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

import { cn } from "@/lib/utils";
import { Icon } from "./icon";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer relative size-4 shrink-0 rounded-sm border-[1.5px] border-outline bg-transparent transition-colors duration-[var(--duration-short-3)] ease-[var(--ease-emphasized)] motion-reduce:transition-none focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2 before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:size-10 before:rounded-full before:bg-foreground/8 before:opacity-0 before:transition-opacity before:duration-[var(--duration-short-3)] before:ease-[var(--ease-emphasized)] motion-reduce:before:transition-none before:content-[''] hover:before:opacity-100 active:before:bg-foreground/12 active:before:opacity-100 data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground data-[state=checked]:hover:before:bg-primary/8 data-[state=checked]:active:before:bg-primary/12 disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none disabled:hover:before:opacity-0",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("relative z-10 flex items-center justify-center text-current size-3")}
    >
      <Icon icon="lucide:check" size={12} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
